import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appOnlyLetters]'
})
export class OnlyLettersDirective {
  // When true digits are left untouched so that validators can report them instead of silently removing them
  @Input() keepDigits: boolean = false;

  constructor(private ngControl: NgControl) {}

  @HostListener('blur') onBlur() {
    const control = this.ngControl.control;
    const value = control?.value;

    if (typeof value === 'string' && value) {
      control.patchValue(this.normalizeValue(value));
    }
  }

  private normalizeValue(value: string): string {
    const allowedCharacters = this.keepDigits ? /[^a-zA-Z0-9- ]/g : /[^a-zA-Z- ]/g;

    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(allowedCharacters, '')
      .trim();
  }
}
